import { render, staticRenderFns } from "./createTag.vue?vue&type=template&id=7cea9f52&scoped=true&"
import script from "./createTag.vue?vue&type=script&lang=js&"
export * from "./createTag.vue?vue&type=script&lang=js&"
import style0 from "./createTag.vue?vue&type=style&index=0&id=7cea9f52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cea9f52",
  null
  
)

component.options.__file = "createTag.vue"
export default component.exports